<main class="auth-page auth-flow-page min-vh-100 position-relative overflow-hidden bg-white text-dark">
  <div class="container position-relative min-vh-100 d-flex flex-column px-3 py-3 py-lg-4">
    <section class="flex-grow-1 d-flex align-items-center py-3">
      <div class="row align-items-center justify-content-center g-5 w-100 mx-0">
        <aside class="col-lg-5 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
          <div class="aic-hero-orb-wrap position-relative mt-0 mb-4">
            <div class="aic-hero-ring aic-hero-ring-outer position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <div class="aic-hero-ring aic-hero-ring-mid position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <router-link
              to="/"
              class="aic-hero-orb position-absolute rounded-circle d-flex align-items-center justify-content-center"
              aria-label="AI Campus Data Intelligence home"
            >
              <span class="aic-hero-orb-mark d-block"></span>
            </router-link>
          </div>
          <p class="text-secondary small fw-semibold text-uppercase mt-3 mb-2">Secure verification</p>
          <h1 class="fs-3 fw-bold text-dark mb-3">One code keeps every insight protected.</h1>
          <p class="text-secondary small mb-0">
            Confirm your identity before opening the property intelligence workspace.
          </p>
        </aside>

        <section class="auth-panel col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 card border border-dark bg-white shadow-lg rounded-4 p-4 text-dark mx-auto">
          <p class="text-secondary small fw-semibold text-uppercase mb-2">Secure verification</p>
          <h1 class="fs-3 fw-bold text-dark mb-2">Check your email</h1>
          <p class="text-secondary small mb-3">
            We sent a 6-digit security code to <strong>{{ email }}</strong>.
          </p>

          <SnackbarMessage
            :error-message="error_message"
            :success-message="success_message"
            @dismiss-error="error_message = ''"
            @dismiss-success="success_message = ''"
          />

          <div v-if="is_loading" class="text-secondary text-center mb-3">
            <div class="spinner-border spinner-border-sm me-2 text-danger"></div>
            <span>Verifying code...</span>
          </div>

          <form v-if="!is_loading" @submit.prevent="submit_otp">
            <div class="d-flex justify-content-between gap-2 mb-3 otp-inputs">
              <input
                v-for="(digit,index) in otp"
                :key="index"
                v-model="otp[index]"
                maxlength="1"
                inputmode="numeric"
                autocomplete="one-time-code"
                class="form-control form-control-sm flex-fill text-center otp-input-box auth-otp-box bg-white border-secondary text-dark rounded-3 shadow-sm"
                @input="handle_input(index,$event)"
                @paste="handle_paste(index,$event)"
                @keydown.backspace="handle_backspace(index,$event)"
              />
            </div>

            <button class="btn btn-danger btn-sm rounded-pill fw-semibold w-100 px-3 py-2 shadow-sm mb-3">
              Verify code
            </button>

            <div class="text-secondary text-center mb-3 p-3 border border-secondary rounded-4 bg-light">
              <p class="small mb-1">
                Didn't receive the code?
                <button type="button" class="btn btn-link text-danger fw-bold p-0 text-decoration-none" @click="resend_otp">
                  Resend OTP
                </button>
              </p>

              <p class="small mb-0">
                You can resend in <strong>{{ formatted_timer }}</strong>
              </p>
            </div>

            <p class="text-center small mb-0">
              <router-link to="/login" class="text-danger fw-bold text-decoration-none">
                <i class="bi bi-arrow-left me-1"></i> Back to login
              </router-link>
            </p>
          </form>
        </section>
      </div>
    </section>
  </div>
</main>
